import TiltedCard from './TiltedCard'

export default function TiltedSectionCard({ imageSrc, title, blurb, href }) {
  return (
    <TiltedCard
      imageSrc={imageSrc}
      altText={title}
      overlayContent={
        <div className="text-center px-6 py-8 max-w-2xl mx-auto rounded-lg bg-background/70 backdrop-blur-sm">
          <h2 className="text-3xl font-bold mb-4 text-accent-text">{title}</h2>
          <p className="text-text/90 mb-6">{blurb}</p>
          <a href={href} className="inline-block text-accent-text hover:underline">
            Read more →
          </a>
        </div>
      }
    />
  )
}
